meedy.factory('meedy.dictionaryModel', ['$rootScope', 'meedy.baseModel', 'meedy.dictionaryService',
    function($rootScope, baseModel, dictionaryService) {

	    function DictionaryModel() {

            this.getStates = function() {
                dictionaryService.getStates().then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.DICTIONARY.GET_STATES.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.DICTIONARY.GET_STATES.ERROR, error);
                    }
                )
            };

            this.getSpecializations = function() {
                dictionaryService.getSpecializations().then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.DICTIONARY.GET_SPECIALIZATIONS.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.DICTIONARY.GET_SPECIALIZATIONS.ERROR, error);
                    }
                )
            };

            this.getAcademicTitles = function() {
                dictionaryService.getAcademicTitles().then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.DICTIONARY.GET_ACADEMIC_TITLES.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.DICTIONARY.GET_ACADEMIC_TITLES.ERROR, error);
                    }
                )
            };

	    }
	
	    return new DictionaryModel();
	}
]);
